(function () {

  function updateBadges(productData, optionContainers) {
    var options = productData.options;
    var variants = productData.variants;

    optionContainers.forEach(function (optionContainer) {
      var optionName = optionContainer.getAttribute('option-name');
      var optionIndex = options.indexOf(optionName);
      if (optionIndex === -1) return;

      var otherSelections = {};
      optionContainers.forEach(function (other) {
        var otherName = other.getAttribute('option-name');
        if (otherName === optionName) return;
        var otherIndex = options.indexOf(otherName);
        if (otherIndex === -1) return;
        var selected = other.querySelector('li.swatch-selected');
        if (selected) otherSelections[otherIndex] = selected.getAttribute('value');
      });

      optionContainer.querySelectorAll('li[type="select_value"]').forEach(function (li) {
        var value = li.getAttribute('value');
        var existing = li.querySelector('.cartel-sale-badge');
        if (existing) existing.remove();

        var bestDiscount = 0;

        if (optionIndex === 0) {
          variants.forEach(function (variant) {
            if (variant.options[0] !== value || !variant.on_sale) return;
            if (variant.discount > bestDiscount) bestDiscount = variant.discount;
          });
        } else {
          var filterIndices = [];
          for (var i = 0; i < optionIndex; i++) {
            if (otherSelections[i] !== undefined) filterIndices.push(i);
          }

          variants.forEach(function (variant) {
            if (variant.options[optionIndex] !== value || !variant.on_sale) return;
            var matches = filterIndices.every(function (i) {
              return variant.options[i] === otherSelections[i];
            });
            if (matches && variant.discount > bestDiscount) bestDiscount = variant.discount;
          });

          if (bestDiscount === 0 && otherSelections[0]) {
            variants.forEach(function (variant) {
              if (variant.options[optionIndex] !== value || !variant.on_sale) return;
              if (variant.options[0] !== otherSelections[0]) return;
              if (variant.discount > bestDiscount) bestDiscount = variant.discount;
            });
          }
        }

        if (bestDiscount > 0) {
          var badge = document.createElement('span');
          badge.className = 'cartel-sale-badge';
          badge.textContent = '-' + bestDiscount + '%';
          var inner = li.querySelector('.d-flex');
          if (inner) inner.appendChild(badge);
        }
      });
    });
  }

  function initBadges() {
    document.querySelectorAll('[id^="vsk-sale-data-"]').forEach(function (script) {
      if (script.dataset.badgesInit) return;

      var productData;
      try { productData = JSON.parse(script.textContent); } catch (e) { return; }

      var variantSelects = script.closest('variant-selects');
      var root = variantSelects || document;

      var optionContainers = root.querySelectorAll('[option-name]');
      if (!optionContainers.length) optionContainers = document.querySelectorAll('[option-name]');
      if (!optionContainers.length) return;

      script.dataset.badgesInit = 'true';
      updateBadges(productData, optionContainers);

      var observer = new MutationObserver(function (mutations) {
        var changed = mutations.some(function (m) {
          if (m.type === 'attributes' && m.attributeName === 'class' && m.target.tagName === 'LI') return true;
          if (m.type === 'childList') {
            return Array.from(m.addedNodes).some(function (n) {
              return n.nodeType === 1 && (
                n.tagName === 'LI' ||
                (n.querySelectorAll && n.querySelectorAll('li[type="select_value"]').length > 0)
              );
            });
          }
          return false;
        });
        if (changed) updateBadges(productData, optionContainers);
      });

      optionContainers.forEach(function (container) {
        observer.observe(container, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class'],
          childList: true
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBadges();
    setTimeout(initBadges, 600);
    setTimeout(initBadges, 1500);
  });

})();

